import React from 'react';
import { stripHtml } from '../helpers';

export default function TextDiff({
  beforeValue,
  afterValue,
  vertical = false,
}) {
  const empty = <em className="text-gray-400">empty</em>;
  const before = stripHtml(beforeValue ?? '') || empty;
  const after = stripHtml(afterValue ?? '') || empty;

  if (before === after) {
    return <span className="text-gray-700">{after || empty}</span>;
  }

  return (
    <div
      className={[
        'flex',
        vertical ? 'flex-col' : 'items-center space-x-2',
      ].join(' ')}
    >
      <div className="px-2 py-0.5 bg-red-100 text-red-600 rounded text-sm">
        {before}
      </div>
      {!vertical && (
        <span className="text-gray-400">
          <i className="fa fa-arrow-right" />
        </span>
      )}
      <div className="px-2 py-0.5 bg-green-100 text-green-600 rounded text-sm">
        {after}
      </div>
      {!before && !after && <em className="text-gray-400">empty</em>}
    </div>
  );
}
